import { useGetCatalog } from '../../../../../services/modules/catalogs/catalogs.queries';
import {
  UseCatalogEffectiveViewParams,
  UseCatalogEffectiveViewResult,
} from './useCatalogEffectiveView.types';
import { useCatalogGroupParams } from './useCatalogGroupParams';
import { useCatalogSortParams } from './useCatalogSortParams';

export const useCatalogEffectiveView = ({
  catalogId,
  canPersist,
}: UseCatalogEffectiveViewParams): UseCatalogEffectiveViewResult => {
  const catalogQuery = useGetCatalog({ id: catalogId }, { enabled: !!catalogId });

  const { sortParams, isSettled: isSortSettled } = useCatalogSortParams({ catalogId, canPersist });

  const { groupParams, isSettled: isGroupSettled } = useCatalogGroupParams({
    catalogId,
    canPersist,
  });

  return {
    sortCriterion: sortParams.orderBy ?? catalogQuery.data?.sectionSortCriterion,
    groupBy: groupParams.groupBy ?? catalogQuery.data?.viewGroupBy,
    isSettled: isSortSettled && isGroupSettled,
  };
};
